import {injectable} from "inversify";
import {Service} from "../interface/service";

@injectable()
export class LoadingService implements Service {

    protected $modal:JQuery;
    protected modalOuter = '<div class="c-loading reveal" data-reveal></div>';
    protected modalBody = '<div class="progress progress-striped active" style="height:30px;"><div class="progress-bar progress-bar-success" role="progressbar" style="width: 100%"></div>';

    protected buildModal = () => {
        let $modal = $(this.modalOuter);
        let $modalBody = $(this.modalBody);
        $modal.append($modalBody);
        new Foundation.Reveal($modal);
        return $modal;
    };

    protected destroyModal = () => {
        this.$modal.foundation('close');
        this.$modal.remove();
        this.$modal = undefined;
    };

    public showLoading = () => {
        if (undefined !== this.$modal) {
            this.destroyModal();
        }
        this.$modal = this.buildModal();
        this.$modal.foundation('open');
        return this.$modal;
    };



    public hideLoading = () => {
        if (undefined !== this.$modal) {
            this.destroyModal();
        }
    };
}